import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TobaccoDashboardComponent } from './tobacco-dashboard.component';
import { PdfpreviewComponent } from './pdfpreview/pdfpreview.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {
  MatNativeDateModule,
  MatRippleModule,
  MAT_DATE_FORMATS,
} from '@angular/material/core';

@NgModule({
  declarations: [TobaccoDashboardComponent, PdfpreviewComponent],
  imports: [
    MatToolbarModule,
    CommonModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    MatDatepickerModule,
    MatSelectModule,
    MatTooltipModule,
    MatDialogModule,
    MatDividerModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatNativeDateModule,
    MatRippleModule
  ],
  providers: [],
  bootstrap: [TobaccoDashboardComponent],
  exports: [TobaccoDashboardComponent],
  entryComponents: [PdfpreviewComponent],
})
export class TobaccoDashboardModule {}
